"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bbox2Points = void 0;
var utils_1 = require("../../../utils");
var bbox_point_1 = require("../../types/record/bbox-point");
var bbox2Points = function (bbox) {
    var _a = bbox.rect, top = _a.top, left = _a.left, width = _a.width, height = _a.height;
    var x0 = left;
    var x1 = left + width / 2;
    var x2 = left + width;
    var y0 = top;
    var y1 = top + height / 2;
    var y2 = top + height;
    return (0, utils_1.IList)([
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x0, y: y0 }),
            location: 'nw'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x0, y: y1 }),
            location: 'w'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x0, y: y2 }),
            location: 'sw'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x1, y: y0 }),
            location: 'n'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x1, y: y2 }),
            location: 's'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x2, y: y0 }),
            location: 'ne'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x2, y: y1 }),
            location: 'e'
        }),
        (0, bbox_point_1.IBboxPoint)({
            parent: bbox,
            centerPos: (0, utils_1.IPos)({ x: x2, y: y2 }),
            location: 'se'
        })
    ]);
};
exports.bbox2Points = bbox2Points;
